import { useTranslation } from "react-i18next";

import { Button } from "../Button";
import { ArrowLeft, ArrowRight } from "lucide-react";

interface PaginationControlProps {
  preOnClick: () => void;
  preDisabled: boolean;
  nextOnClick: () => void;
  nextDisabled: boolean;
}

export const PaginationControl = ({
  preOnClick,
  preDisabled,
  nextOnClick,
  nextDisabled,
}: PaginationControlProps) => {
  const { t } = useTranslation();

  return (
    <div className="mx-auto flex w-full justify-center mt-6">
      <div className="flex flex-row items-center gap-1">
        <Button
          variant="outline"
          size="icon"
          onClick={preOnClick}
          disabled={preDisabled}
          aria-label={t("general.actions.previous")}
          className="h-10 w-10 text-neutral-500 rounded-sm border border-neutral-500 bg-white hover:border-red hover:text-red"
        >
          <ArrowLeft className="size-5" />
        </Button>
        <Button
          variant="outline"
          size="icon"
          onClick={nextOnClick}
          disabled={nextDisabled}
          aria-label={t("general.actions.next")}
          className="h-10 w-10 text-neutral-500 rounded-sm border border-neutral-500 bg-white hover:border-red hover:text-red"
        >
          <ArrowRight className="size-5" />
        </Button>
      </div>
    </div>
  );
};
